const backendUrl = 'https://hive-cycle.herokuapp.com';

export default backendUrl;
